<template>
  <div>
    <div class="gap-20px flex flex-col items-center sm:flex-row">
      <div class="w-[200px] shrink-0">
        <img class="w-full" :src="image.image" :alt="image.description" />
      </div>
      <div>
        <Heading :headingTag="headingTag" :style="headingStyle">
          <slot name="title"></slot>
        </Heading>
        <Paragraphs :text="body"> </Paragraphs>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from "../Atoms/Heading.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";

export default {
  components: {
    Paragraphs,
    Heading,
  },

  props: {
    headingTag: {
      type: String,
      required: false,
      default: "h3",
    },
    headingStyle: {
      type: String,
      requried: false,
      default: "h3",
    },
    image: {
      type: Object,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
  },

  setup(props) {},
};
</script>
